module.exports = __webpack_public_path__ + "static/media/Confirmation Bias - glenn-carstens-peters-RLw-UC03Gwc-unsplash.9de01d05.jpg";